import { APP_CONFIG } from '../../../app.config';

export const MAIN_SCREEN_CONFIG = {
  requests: {
    getServerVersion: {
      name: 'getServerVersion',
      url: `${APP_CONFIG.apiBaseUrl}/version`,
    },
  },
};
